import RouteView from '@/router/RouteView.vue';
import Goods from './index.vue'; // 课程中心
import ClassBuy from './ClassBuy/index.vue'; // 课程购买
import ClassDetail from './ClassDetail/index.vue'; // 课程详情

export default [
  {
    path: '/goods',
    name: 'goods',
    component: Goods,
    meta: {
      title: '课程中心',
    },
  },
  {
    path: '/goods',
    component: RouteView,
    meta: {
      title: '课程中心',
    },
    children: [
      {
        path: '/goods/classDetail',
        name: 'classDetail2',
        component: ClassDetail,
        meta: {
          title: '课程详情',
        },
      },
      {
        path: '/goods/classDetail',
        component: RouteView,
        meta: {
          title: '课程详情',
        },
        children: [
          {
            path: '/goods/classDetail/classBuy',
            name: 'classBuy',
            component: ClassBuy,
            meta: {
              title: '课程购买',
            },
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/Goods/router.js